import { render, staticRenderFns } from "./WorkClientPersonModal.vue?vue&type=template&id=5865cbd6&scoped=true&"
import script from "./WorkClientPersonModal.vue?vue&type=script&lang=js&"
export * from "./WorkClientPersonModal.vue?vue&type=script&lang=js&"
import style0 from "./WorkClientPersonModal.vue?vue&type=style&index=0&id=5865cbd6&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5865cbd6",
  null
  
)

export default component.exports